import type { JSX } from 'react';
import { Badge } from '@/components/ui/badge';
import { Icon } from '@/components/ui/icon';
import { cn } from '@/lib/utils';

export interface ReportUnitPickerCardProps {
  title: string;
  planningLabel: string;
  onSelect: () => void;
  selected?: boolean;
  isDraft?: boolean;
  helper?: string;
  className?: string;
}

export function ReportUnitPickerCard({
  title,
  planningLabel,
  onSelect,
  selected = false,
  isDraft = false,
  helper,
  className,
}: ReportUnitPickerCardProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        'group flex w-full flex-col gap-2 rounded-lg border border-[var(--border-default)] bg-surface p-4 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue-500/30',
        selected
          ? 'border-brand-blue-300 bg-brand-blue-50/60 shadow-md'
          : 'hover:border-brand-blue-300',
        className
      )}
      aria-pressed={selected}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-text-primary">{title}</p>
          {helper ? <p className="text-xs text-text-secondary">{helper}</p> : null}
        </div>
        {isDraft ? <Badge variant="secondary">Bozza</Badge> : null}
      </div>
      <div className="flex items-center gap-2 text-xs text-text-secondary">
        <Icon name="date_range" className="text-sm text-brand-blue-500" />
        <span>
          Pianificazione <span className="font-medium text-text-primary">{planningLabel}</span>
        </span>
      </div>
      <p className="text-xs text-text-tertiary">
        {isDraft ? 'Apri la bozza esistente' : 'Seleziona per creare il report'}
      </p>
    </button>
  );
}
